<template>
  <div
    class="table-grid-th"
    ref="$el"
    :class="{ 'table-grid-th--left-border': props.isLeftBorder }"
    :style="style"
  >
    <!-- <div class="table-grid-th__left-border" v-if="props.isLeftBorder"></div> -->

    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
const $el = ref<HTMLElement>();

const props = defineProps({
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<String[]>, default: () => [] },
  /**
   * Отключить или включить бордер слеа ячейки
   */
  isLeftBorder: { type: Boolean as PropType<Boolean>, default: true },
});
/**
 * Стили
 */
const style = computed(() => {
  return { gridTemplateColumns: props.columns.toString().replaceAll(",", " ") };
});
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
